import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useSnackbar } from 'notistack';
import api from '../api';
import { getBackendUrl } from '../util/envFn';
import { useLogin } from '../context/Login/LoginContext';

const GoogleLoginButton = () => {
    const { enqueueSnackbar } = useSnackbar();
    const { login } = useLogin();

    const handleSuccess = async (response: any) => {
        try {
            const result = await api.post(getBackendUrl('/auth/google'), {
                token: response.credential
            });
            const { user, token } = result.data;
            login(user, token);
            enqueueSnackbar('Login successful', { variant: 'success' });
        } catch (error) {
            console.error('Login failed:', error);
            enqueueSnackbar('Login failed. Please try again.', { variant: 'error' });
        }
    };

    const handleError = () => {
        enqueueSnackbar('Login failed. Please try again.', { variant: 'error' });
    };

    return (
        <GoogleLogin
            onSuccess={handleSuccess}
            onError={handleError}
        />
    );
};

export default GoogleLoginButton; 